import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import layoutReducer from "./layout/layoutReducer";
import userReducer from "./user/userReducer";
import assetsReducer from "./assets/assetsReducer";
import geofenceReducer from "./geofence/geofenceReducer";
import notificationReducer from "./notifications/notificationReducer";
import eventReducer from "./events/eventReducer"
import edgeDevicesReducer from "./edge-devices/edgeDevicesReducer";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["user"],
};

const rootReducer = combineReducers({
  layout: layoutReducer,
  user: userReducer,
  assets: assetsReducer,
  geofences: geofenceReducer,
  notifications:notificationReducer,
  events:eventReducer,
  edgeDevices: edgeDevicesReducer
});

export const persistedReducer = persistReducer(persistConfig, rootReducer);
